import React from 'react'
import TarjetaContenido from 'components/TarjetaContenido/TarjetaContenido'
import PaginaPorDefecto from './Default'

export default function Inicio() {
  return (
    <PaginaPorDefecto titulo='Dashboard'>
      <TarjetaContenido titulo='Collapsable Card Example'>
        <p>
          This is a collapsable card example usiong bootstrap's built in
          collapse functionality. <b>Click on the card header</b> to see the
          card body collapse and expand!
        </p>
      </TarjetaContenido>

      <TarjetaContenido titulo='Informacion personal'>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Sit, quos
          non earum incidunt itaque aliquid, cumque quo quaerat id eaque
          voluptates magnam. Aut mollitia, temporibus cum odit similique eius
          sint.
        </p>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Sit, quos
          non earum incidunt itaque aliquid, cumque quo quaerat id eaque
          voluptates magnam. Aut mollitia, temporibus cum odit similique eius
          sint.
        </p>

        <div>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet
            explicabo ea ullam omnis necessitatibus tempora ab earum eaque,
            labore unde voluptates ipsam excepturi consequuntur aperiam,
            pariatur voluptatum enim, deleniti quos?
          </p>
        </div>
      </TarjetaContenido>

      <TarjetaContenido titulo='Elementos esenciales'>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Sit, quos
          non earum incidunt itaque aliquid, cumque quo quaerat id eaque
          voluptates magnam. Aut mollitia, temporibus cum odit similique eius
          sint.
        </p>

        <div>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet
            explicabo ea ullam omnis necessitatibus tempora ab earum eaque,
            labore unde voluptates ipsam excepturi consequuntur aperiam,
            pariatur voluptatum enim, deleniti quos?
          </p>
        </div>
      </TarjetaContenido>
    </PaginaPorDefecto>
  )
}
